<template>
  <div class="surface-tension-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F = γ · L | h = 2γcosθ / ρgr$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：水滴与毛细管 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 毛细管 A -->
            <rect x="100" y="50" width="10" height="150" fill="none" stroke="#888" />
            <rect x="101" :y="200 - h1" width="8" :height="h1" fill="#00d2ff" opacity="0.6" />
            
            <!-- 毛细管 B -->
            <rect x="200" y="50" width="30" height="150" fill="none" stroke="#888" />
            <rect x="201" :y="200 - h2" width="28" :height="h2" fill="#00d2ff" opacity="0.6" />

            <!-- 水面 -->
            <rect x="50" y="200" width="300" height="10" fill="#00d2ff" opacity="0.3" />

            <text x="100" y="45" fill="#888" font-size="9" text-anchor="middle">细管 (r小)</text>
            <text x="215" y="45" fill="#888" font-size="9" text-anchor="middle">粗管 (r大)</text>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>上升高度 h</label>
               <span class="val">{{ (h1/10).toFixed(1) }} cm</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full">
                  <label>表面张力系数 (γ)</label>
                  <el-slider v-model="gamma" :min="10" :max="100" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>液体表面分子受到的向内引力形成<strong>表面张力</strong>。在细管中，张力会导致液体沿管壁上升，管径越细（r 越小），<strong>毛细现象</strong>越明显。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurfaceTensionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      gamma: 50
    }
  },
  computed: {
    h1() {
       // h inversely proportional to r
       return (this.gamma / 50) * 80;
    },
    h2() {
       return (this.gamma / 50) * 20;
    }
  }
}
</script>

<style scoped lang="scss">
.surface-tension-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { color: #00d2ff; font-family: monospace; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { .col-full { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } } }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
